/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React from 'react'

export default function BlockchainAnalyticsIcon(props) {
  return (
    <svg
      width={props?.size || '14'}
      height={props?.size || '18'}
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13 17V10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 17V1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 17V6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
